import { render, staticRenderFns } from "./PracticePolicies.vue?vue&type=template&id=cf836f52"
import script from "./PracticePolicies.vue?vue&type=script&lang=js"
export * from "./PracticePolicies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports